import { Link } from 'react-router-dom';
import { EmptyState } from '@adop/ui';
import { Compass } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-lg px-4 py-24">
      <EmptyState
        icon={<Compass className="h-6 w-6" />}
        title="Page not found"
        description="The page you were looking for does not exist."
        action={
          <Link to="/" className="text-sm font-medium text-zinc-900 underline">
            Go to the marketplace
          </Link>
        }
      />
    </div>
  );
}
